import { AppointmentDetailsAction } from '../actions/AppointmentDetailsAction';
import { SequenceManagerAction } from '../actions/SequenceManagerAction';

const initState = {
    requestBody: {
        sectionId: "appointmentDetails",
        steps: [
            {
                sequence: "0",
                stepId: "",
                fields: [
                    {
                        name: "",
                        value: ""
                    },
                    {
                        name: "",
                        value: ""
                    },
                    {
                        name: "Date",
                        value: ""
                    },
                    {
                        name: "AppointmentStart",
                        value: ""
                    },
                    {
                        name: "AppointmentEnd",
                        value: ""
                    },
                    {
                        name: "Slot Id",
                        value: ""
                    }
                ]
            }
        ]
    },
    getAppointmentsSlotsResponse: {

    },
    reserveAppointmentResponse: {

    }
}

const AppointmentDetailsReducer = (state: any = initState, action: any) => {
    const { type } = action;
    const { payload } = action;
    var AppointmnetDetailsValue = { ...state.requestBody.steps };

    switch (type) {
        case AppointmentDetailsAction.GET_APPOINTMENTS_SUCCESS:
            return { ...state, getAppointmentsSlotsResponse: payload };

        case AppointmentDetailsAction.RESERVE_APPOINTMENT_SUCCESS:
            if (payload.provider.toLowerCase() !== 'mobily') {
                AppointmnetDetailsValue[0].stepId = "Non-MobilyappointmentDetails";
                AppointmnetDetailsValue[0].fields[0].name = "Non-Mobily GET Appointment";
                AppointmnetDetailsValue[0].fields[1].name = "Non-Mobily Reserve Appointment";
            } else {
                AppointmnetDetailsValue[0].stepId = "MobilyappointmentDetails";
                AppointmnetDetailsValue[0].fields[0].name = "Mobily GET Appointment";
                AppointmnetDetailsValue[0].fields[1].name = "Mobily Reserve Appointment";
            }
            AppointmnetDetailsValue[0].fields[0].value = JSON.stringify(state.getAppointmentsSlotsResponse);
            AppointmnetDetailsValue[0].fields[1].value = JSON.stringify(payload.response.data);
            AppointmnetDetailsValue[0].fields[2].value = payload.selectedDate.split('.')[0] + 'Z';
            AppointmnetDetailsValue[0].fields[3].value = payload.appointmentStart;
            AppointmnetDetailsValue[0].fields[4].value = payload.appointmentEnd;
            AppointmnetDetailsValue[0].fields[5].value = payload.slotId;
            return { ...state, reserveAppointmentResponse: payload.response };

        case AppointmentDetailsAction.SKIP_APPOINTMENT_SUCCESS:
            AppointmnetDetailsValue[0].stepId = "MobilyappointmentDetails";
            AppointmnetDetailsValue[0].fields[0].name = "Mobily GET Appointment";
            AppointmnetDetailsValue[0].fields[1].name = "Mobily Reserve Appointment";
            return state;
            
        case SequenceManagerAction.DISPLAY_PREVIOUS_SECTION:
        case SequenceManagerAction.DISPLAY_SECTION:
            return { ...state, getAppointmentsSlotsResponse: {}, reserveAppointmentResponse: {} }

        case SequenceManagerAction.GET_CHECKOUT_SUCCESS:
            let section = payload.sections.filter((section: any) => {
                return (section.sectionId === 'appointmentDetails')
            });
            if (section.length > 0) {
                for (let i = 0; i < AppointmnetDetailsValue[0].fields.length; i++) {
                    const AppointmnetDetailsField = section[0].steps[0].fields.filter((field: any) => { return (field.name === AppointmnetDetailsValue[0].fields[i].name) })[0];
                    AppointmnetDetailsValue[0].fields[i].value = AppointmnetDetailsField ? AppointmnetDetailsField.value : "";
                }
            }
            return state;

        default:
            return state;
    }
}

export default AppointmentDetailsReducer;